// /pages/carrossier/FormulaireB/components/SectionDeclaration.js
import React from "react";

const SectionDeclaration = ({ formData, setFormData, errors, produit, loading }) => {
  return (
    <>
      {/* Section 11 : Déclaration sur l'honneur */}
      <section className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold mb-6 text-green-600 flex items-center gap-2">
          <span className="text-xl">✅</span>
          11. Déclaration sur l'honneur
        </h3>
        
        <div className="bg-green-50 p-4 rounded-xl border border-green-200">
          <p className="text-sm text-gray-700 mb-4">
            Je soussigné(e), certifie que le montage de la porte automatique <strong>{produit?.name || "Produit HUSKY"}</strong> avec système CLEVER SAFE a été effectué conformément aux règles de l'art et aux prescriptions techniques du fabricant. Tous les contrôles de sécurité spécifiques à la configuration HUSKY ont été réalisés avec succès.
          </p>
          
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={formData.declarationHonneur}
              onChange={(e) => setFormData(prev => ({ ...prev, declarationHonneur: e.target.checked }))}
              className={`w-4 h-4 text-green-600 focus:ring-green-500 ${errors.declarationHonneur ? 'border-red-500' : ''}`}
            />
            <div>
              <span className="font-medium text-gray-900">J'atteste sur l'honneur l'exactitude de ces informations *</span>
              <p className="text-sm text-gray-600 mt-1">
                Cette déclaration engage ma responsabilité professionnelle pour l'installation CLEVER SAFE
              </p>
            </div>
          </label>
          {errors.declarationHonneur && (
            <p className="text-red-500 text-xs mt-2">{errors.declarationHonneur}</p>
          )}
        </div>
      </section>

      {/* Validation et soumission */}
      <section className="bg-gradient-to-r from-green-50 via-emerald-50 to-green-50 p-6 rounded-2xl border border-green-200">
        <div className="flex items-start gap-4">
          <div className="text-green-600 text-2xl mt-1">⚠️</div>
          <div>
            <h4 className="font-semibold text-green-800 mb-2">Validation du contrôle - Configuration HUSKY CLEVER SAFE</h4>
            <p className="text-green-700 text-sm mb-4">
              En soumettant ce formulaire, je certifie avoir effectué tous les contrôles requis 
              selon les procédures techniques HUSKY et que l'installation CLEVER SAFE est conforme aux spécifications avancées.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                type="submit"
                disabled={loading}
                className={`flex items-center gap-2 px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-200 transform ${
                  loading
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                    : "bg-gradient-to-r from-green-600 to-emerald-600 text-white shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
                }`}
              >
                {loading ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    Enregistrement en cours...
                  </>
                ) : (
                  <>
                    <span className="text-xl">✅</span>
                    Enregistrer formulaire HUSKY
                  </>
                )}
              </button>
              
              <button
                type="button"
                onClick={() => window.history.back()}
                className="flex items-center gap-2 px-6 py-4 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-medium transition-colors"
              >
                <span>←</span>
                Retour
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionDeclaration;